// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container {
  top: 40px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  padding: 5px 10px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: bold;
  display: flex;
  align-content: center;
  align-items: center;
  background: #333333;
  color: #d7d7d7;
  font-size: 15px;
  text-align: center;
  width: 90%;
}
.button {
  margin: 10px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/services/upgrade.service.ts"],"names":[],"mappings":";AACA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;AACd","sourcesContent":["\n.container {\n  top: 40px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%);\n  padding: 5px 10px;\n  border-radius: 5px;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  background: #333333;\n  color: #d7d7d7;\n  font-size: 15px;\n  text-align: center;\n  width: 90%;\n}\n.button {\n  margin: 10px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
